import React, {useEffect, useState, Component, Fragment} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Placeholder,Popup } from 'semantic-ui-react';
import {
  Menu,
  Container,
  Segment,
  Table,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Step,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import QRCode from 'qrcode.react';
import Clipboard from 'react-clipboard.js';
import { Sparklines, SparklinesBars, SparklinesLine, SparklinesReferenceLine } from 'react-sparklines';

var id = false;
const Term = function(){
  return <Fragment>
  <svg id="linux" viewBox="0 0 36 24" style={{"color":"#333","width":"30px","marginRight":"8px", "verticalAlign": "middle"}} >
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 3.5C6 2.67157 6.67157 2 7.5 2H27.5C28.3284 2 29 2.67157 29 3.5V20.5C29 21.3284 28.3284 22 27.5 22H7.5C6.67157 22 6 21.3284 6 20.5V3.5ZM8.96967 4.96967C9.26256 4.67678 9.73744 4.67678 10.0303 4.96967L13.5303 8.46967C13.8232 8.76256 13.8232 9.23744 13.5303 9.53033L10.0303 13.0303C9.73744 13.3232 9.26256 13.3232 8.96967 13.0303C8.67678 12.7374 8.67678 12.2626 8.96967 11.9697L11.9393 9L8.96967 6.03033C8.67678 5.73744 8.67678 5.26256 8.96967 4.96967ZM13 15.2C12.5582 15.2 12.2 15.5582 12.2 16C12.2 16.4418 12.5582 16.8 13 16.8H20.5C20.9418 16.8 21.3 16.4418 21.3 16C21.3 15.5582 20.9418 15.2 20.5 15.2H13Z" fill="currentColor"></path>
  </svg></Fragment>;
}

let average = (array) => array.reduce((a, b) => a + b) / array.length;

function Guide(props){

  var base          = 30;
  const {t}         = props;
  const mobile      = /Android|iPhone|iPod/.test(navigator.userAgent);
  const port        = props.data.port;
  const prefix      = props.data.prefix;
  const code        = props.data.code;
  const hashed      = props.data.hashed;
  const user_id     = props.data.user_id;
  const user_vip    = props.data.user_vip;
  const leftDays    = props.data.leftDays;

  if(user_id < 115375){
    base = 20;
  }

  var subscribe_endpoint = "update.glados-config.com";
  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";

  const suburl           = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-terminal.yaml`

  const not_supported = <Fragment>
        <Segment placeholder>
          <Header icon>
            <Icon name='cloud upload' />
            <p>游戏加速仅为 Pro 用户提供</p>
          </Header>
          <Link to="/console/shop">
            <Button primary>升级</Button>
          </Link>
        </Segment>
  </Fragment>

  const [clipboard,setClipboard] = useState(false);

  var panes = [{
      menuItem:<Menu.Item key='pro34'>
        <Term/>Linux
      </Menu.Item>,
      display:true,
      render: () => {
        return (<Tab.Pane style={{padding:"20px",margin:"0px"}}>
              <p>第一步: 开一个新的 Terminal 运行Clash, 启动代理</p>
              <Message color='black'>
              <code>
              <p>user@localhost:~$ curl https://glados.rocks/tools/clash-linux.zip -o clash.zip #下载Clash</p>
              <p>user@localhost:~$ unzip clash.zip</p>
              <p>user@localhost:~$ cd clash</p>
              <p>user@localhost:~$ <b>curl {suburl} > glados.yaml</b> <span>#下载您的终端配置文件</span></p>
              <p>user@localhost:~$ chmod +x ./clash-linux-amd64-v1.10.0</p>
              <p>user@localhost:~$ ./clash-linux-amd64-v1.10.0 -f glados.yaml -d . </p>
              </code>
              </Message>
              clash 打印如下日志说明clash启动成功
              <Message color='black'>
                <pre>
                  INFO[0000] HTTP proxy listening  at: [::]:7890<br/>
                  INFO[0000] SOCKS proxy listening at: [::]:7891<br/>
                  INFO[0000] RESTful API listening at: 127.0.0.1:9090<br/>
                </pre>
              </Message>
              <p>日志提示已经开放了HTTP代理服务端口为7890, SOCK55服务端口为7891.</p>
              <p>后面设置其他程序(浏览器/GIT等)通过7890/7891来代理访问网络就可以了。</p>

              <p>第二步: 使用代理</p>
              <p>1. 例如 Git:</p>
              <p>新开一个Terminal: </p>
              <Message color='black'>
                <pre>
                  user@localhost:~$ git clone https://github.com/twbs/bootstrap.git --config "http.proxy=127.0.0.1:7890"  <br/>
                </pre>
              </Message>

              clash 打印如下日志说明clash完成了工作
              <Message color='black'>
                <pre>
                  INFO[0007] [TCP] 127.0.0.1:54875 --> github.com:443 match DomainKeyword(github) using Proxy
                </pre>
              </Message>

              <p>2. 例如 NPM:</p>
              <Message color='black'>
                <pre>
                  user@localhost:~$  npm config set proxy http://127.0.0.1:7890 <br/>
                  user@localhost:~$  npm install pm2 -g <br/>
                  user@localhost:~$  npm config delete proxy  #取消代理设置<br/>
                </pre>
              </Message>

              <p>3. 通过设置Shell的环境变量, 例如 APT/CURL:</p>
              <Message color='black'>
                <pre>
                  user@localhost:~$ export http_proxy="127.0.0.1:7890" <br/>
                  user@localhost:~$ apt update <br/>
                  user@localhost:~$ apt install wget <br/>
                  user@localhost:~$ export http_proxy="" #取消代理设置<br/>
                </pre>
              </Message>
              <Message color='black'>
                <pre>
                  user@localhost:~$ export http_proxy="127.0.0.1:7890" <br/>
                  user@localhost:~$ curl https://ifconfig.me <br/>
                  user@localhost:~$ export http_proxy="" #取消代理设置<br/>
                </pre>
              </Message>

              <p>4. SSH 通过代理连接服务器, 例如:</p>
              <p>ubuntu 下编辑 ~/.ssh/config 文件:</p>
              <Message color='black'>
                <pre>
                    Host 1.1.1.1<br/>
                    User root<br/>
                    ProxyCommand /usr/bin/nc -X5 -x 127.0.0.1:7891  %h %p<br/>
                </pre>
              </Message>
              连接服务器
              <Message color='black'>
                <pre>
                  ssh root@1.1.1.1
                </pre>
              </Message>

              <p>5. 桌面型Linux(如Ubuntu 22.04)请打开设置-网络-设置网络代理为SOCK5, 地址为 127.0.0.1, 端口为7891.</p>

              <p>注意: ping 并不是 TCP 应用，因此无法使用Clash的HTTP/SOCK5代理.</p>

              <p>第三步: 管理Clash(可选)</p>
              <p>可以使用 <a href="http://127.0.0.1:9090/ui">Web UI 管理 Clash</a>, Port 填写9090</p>

              <p>项目地址: <a href="https://github.com/Dreamacro/clash">https://github.com/Dreamacro/clash</a></p>
              <p>更多平台下载地址: <a href="https://github.com/Dreamacro/clash/releases">https://github.com/Dreamacro/clash/releases</a></p>
        </Tab.Pane>)
      }
  },{
      menuItem:<Menu.Item key='pro34'>
        <Term/>Mac Terminal
      </Menu.Item>,
      display:true,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

          <p>Step 1. 按照普通向导安装和运行 ClashX </p>
          <p>点击顶部 Clash-Help-Ports, 确认 ClashX 开放的代理端口(默认为7890一个自动适应协议的端口) </p>
          <p>Step 2. 开一个 Terminal, 使用 Clash 的代理端口 </p>

              <p>1. SSH 临时通过代理连接服务器, 例如:</p>
              <Message color='black'>
                <pre>
                  ssh root@1.1.1.1 -o Proxycommand="nc -x 127.0.0.1:7890 %h %p"
                </pre>
              </Message>

              <p>2. SSH 永久通过代理连接服务器, 例如:</p>
              <p>编辑 ~/.ssh/config 文件:</p>
              <Message color='black'>
                <pre>
                  Host 1.1.1.1<br/>
                  User root<br/>
                  ProxyCommand /usr/bin/nc -x 127.0.0.1:7890  %h %p<br/>
                </pre>
              </Message>
              连接服务器
              <Message color='black'>
                <pre>
                  ssh root@1.1.1.1
                </pre>
              </Message>

              <p>3. Curl 例如:</p>
              <Message color='black'>
                <pre>
                  curl --socks5 127.0.0.1:7890  https://ifconfig.me
                </pre>
              </Message>

              <p>4. Git 例如:</p>
              <p>新开一个Terminal: </p>
              <Message color='black'>
                <pre>
                  user@localhost:~$ git clone https://github.com/twbs/bootstrap.git --config "http.proxy=127.0.0.1:7890"  <br/>
                </pre>
              </Message>

          </Tab.Pane>)
      }
  },{
      menuItem:<Menu.Item key='pro34'>
        <Term/>Ubuntu/Fedora Desktop
      </Menu.Item>,
      display:true,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <p><Link to="/console/clash">点击前往Clash的Linux桌面配置说明页面</Link></p>
          </Tab.Pane>)
      }
  },{
      menuItem:<Menu.Item key='pro34'>
        <Term/>Windows CMD/Shell
      </Menu.Item>,
      display:false,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}></Tab.Pane>)
      }
  }
  ]

  return (
    <Fragment>
      <Header as='h2' color="blue">
        Terminals
        <Header.Subheader>
        Terminals Setup
        </Header.Subheader>
      </Header>
      <Tab panes={panes.filter((i)=>{return i.display})} />

    </Fragment>
  )
}






export {Guide};
